import React, { useEffect, useMemo, useState } from 'react'
import { Button, Col, Form, Row, Spinner } from 'react-bootstrap'
import Card from '../../components/Card'
import MasterService from '../../services/master/MasterService'
import { useNavigate } from 'react-router-dom'
import { AsyncPaginate } from 'react-select-async-paginate'
import { FaChevronCircleLeft, FaSave } from 'react-icons/fa'
import UserService from '../../services/user/UserService'
import SweetAlert from 'react-bootstrap-sweetalert'

const TraderAlamatAddEdit = () => {
    let masterService = useMemo(() => new MasterService(), [])
    let userService = useMemo(() => new UserService(), [])
    let navigate = useNavigate()

    useEffect(() => {
        let alamatExisting = JSON.parse(localStorage.getItem("dataAlamatStorage"))
        // console.log(alamatExisting)
        if(!alamatExisting) return
        const fetchDataAlamat = async () => {
            try {
                setValueAlamat(alamatExisting.alamat)
                setValueKodepos(alamatExisting.kodepos)

                const resProp = await masterService.getPropinsiById(alamatExisting.propinsi.substring(0,2))
                setValuePropOpt(resProp.data)

                const resKota = await masterService.getKotaById(alamatExisting.kota)
                setValueKotaOpt(resKota.data)
            } catch (error) {
                console.log(error)
            }
        }
        fetchDataAlamat()
    }, [masterService])

    const [keyForSecondSelect, setKeyForSecondSelect] = useState(0);
    const [valuePropOpt, setValuePropOpt] = useState(null)
    const [valueKotaOpt, setValueKotaOpt] = useState(null)
    const [valueAlamat, setValueAlamat] = useState('')
    const [valueKodepos, setValueKodepos] = useState('')

    const loadOptionPropinsi = async (search, loadedOption, { page = 1 }) => {
        const response = await masterService.listPropinsi(search, page - 1, 10)
        return {
            options: response.data.data,
            hasMore: response.data.data.length >= 10,
            additional: {
                page: page + 1
            }
        }
    }

    const loadOptionKota = async (search, loadedOption, { page = 1 }) => {
        const response = await masterService.listKota(valuePropOpt.kodePropinsi, search, page - 1, 10)
        return {
            options: response.data.data,
            hasMore: response.data.data.length >= 10,
            additional: {
                page: page + 1
            }
        }
    }

    const onChangeAlamat = e => {
        setValueAlamat(e.target.value)
    }

    const onChangeKodepos = e => {
        setValueKodepos(e.target.value)
    }

    const onChangeOptionProp = e => {
        setValuePropOpt(e)
        setKeyForSecondSelect(prevKey => prevKey + 1)
        setValueKotaOpt(null)
    }

    const onChangeOptionKota = e => {
        setValueKotaOpt(e)
    }

    const handleClickBatal = () => {
        localStorage.removeItem('dataAlamatStorage')
        navigate('/setting/trader-alamat')
    }

    const [loadingSave, setLoadingSave] = useState(false)
    const [showConfirmSimpan, setShowConfirmSimpan] = useState(false)
    const handleCloseConfirmSimpan = () => setShowConfirmSimpan(false)
    const [simpanSuccess, setSimpanSuccess] = useState(false)
    const [simpanFailed, setSimpanFailed] = useState(false)

    const handleClickSimpan = () => {
        setShowConfirmSimpan(true)
    }

    const handleClickConfirmSimpan = async () => {
        try {
            setLoadingSave(true)
            let dataAlamat = JSON.parse(localStorage.getItem("dataAlamatStorage"))
            let jsonAlamatTrader = {
                ...dataAlamat,
                kodeTrader: localStorage.getItem("kodeTrader"),
                alamat: valueAlamat,
                propinsi: valuePropOpt.kodePropinsi,
                kota: valueKotaOpt.kodeKota,
                kodepos: valueKodepos,
                statusAlamat: '0'
            }
            const resSaveAlamat = await userService.addTraderAlamat(jsonAlamatTrader)
            if(resSaveAlamat.data.kode === '200'){
                setShowConfirmSimpan(false)
                setSimpanSuccess(true)
            } else {
                setShowConfirmSimpan(false)
                setSimpanFailed(true)
            }
            setLoadingSave(false)
        } catch (error) {
            setLoadingSave(false)
            setShowConfirmSimpan(false)
            setSimpanFailed(true)
        }
    }

    const handleCloseSimpanSuccess = () => {
        setLoadingSave(false)
        setSimpanSuccess(false)
    }

    const handleCloseSimpanFailed = () => {
        setLoadingSave(false)
        setSimpanFailed(false)
    }

    return (
        <>
            <div>
                <Row>
                    <Col sm="12" lg="13">
                        <Card>
                            <Card.Header className="d-flex justify-content-between">
                                <div className="header-title">
                                    <h5 className="card-title">{localStorage.getItem("dataAlamatStorage") !== null ? 'Ubah' : 'Tambah'}  Master Alamat</h5>
                                </div>
                            </Card.Header>
                            <Card.Body>
                                <div className="row">
                                    <div className="col-sm-10">
                                        <Form>
                                            <Form.Group as={Row} className="form-group">
                                                <Form.Label column sm="2" className="control-label align-self-center mb-0" htmlFor="searchNib">Alamat UPI</Form.Label>
                                                <Col sm="5">
                                                    <Form.Control as="textarea" rows={3} placeholder="Alamat UPI" className="form-control-sm" onChange={onChangeAlamat} value={valueAlamat}/>
                                                </Col>
                                            </Form.Group>
                                        </Form>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-10">
                                        <Form>
                                            <Form.Group as={Row} className="form-group">
                                                <Form.Label column sm="2" className="control-label align-self-center mb-0" htmlFor="searchNib">Propinsi</Form.Label>
                                                <Col sm="5">
                                                    <AsyncPaginate
                                                        loadOptions={loadOptionPropinsi}
                                                        value={valuePropOpt}
                                                        getOptionLabel={(option) => option.uraianPropinsi}
                                                        getOptionValue={(option) => option.kodePropinsi}
                                                        additional={{
                                                            page: 1
                                                        }}
                                                        onChange={onChangeOptionProp}
                                                    />
                                                </Col>
                                            </Form.Group>
                                        </Form>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-10">
                                        <Form>
                                            <Form.Group as={Row} className="form-group">
                                                <Form.Label column sm="2" className="control-label align-self-center mb-0" htmlFor="searchNib">Kota</Form.Label>
                                                <Col sm="5">
                                                    <AsyncPaginate
                                                        key={keyForSecondSelect}
                                                        loadOptions={loadOptionKota}
                                                        value={valueKotaOpt}
                                                        getOptionLabel={(option) => option.uraianKota}
                                                        getOptionValue={(option) => option.kodeKota}
                                                        additional={{
                                                            page: 1
                                                        }}
                                                        onChange={onChangeOptionKota}
                                                    />
                                                </Col>
                                            </Form.Group>
                                        </Form>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-10">
                                        <Form>
                                            <Form.Group as={Row} className="form-group">
                                                <Form.Label column sm="2" className="control-label align-self-center mb-0" htmlFor="searchNib">Kode Pos</Form.Label>
                                                <Col sm="2">
                                                    <Form.Control type='text' placeholder="Kode Pos" className="form-control-sm" onChange={onChangeKodepos} value={valueKodepos} />
                                                </Col>
                                            </Form.Group>
                                        </Form>
                                    </div>
                                </div>
                            </Card.Body>
                            <Card.Footer>
                                <Button variant="primary" size='sm' onClick={() => handleClickSimpan()}><FaSave /> Simpan</Button>{' '}
                                <Button variant="danger" size='sm' onClick={() => handleClickBatal()}>
                                    <FaChevronCircleLeft /> Kembali
                                </Button>
                            </Card.Footer>
                        </Card>
                    </Col>
                </Row>
            </div>
            {
                showConfirmSimpan &&
                <SweetAlert
                    title="Simpan Data Alamat"
                    warning
                    showCancel
                    confirmBtnText={
                        loadingSave ? (
                            <>
                                <Spinner animation="border" size="sm" className="me-2" />
                                Proses Simpan...
                            </>
                        ) : (
                            "Simpan"
                        )
                    }
                    confirmBtnBsStyle="primary"
                    cancelBtnText="Batal"
                    cancelBtnBsStyle="secondary"
                    onConfirm={handleClickConfirmSimpan}
                    onCancel={handleCloseConfirmSimpan}
                    focusCancelBtn
                    btnSize="sm"
                    disabled={loadingSave}
                    reverseButtons={true}
                >
                    {loadingSave && (
                        <div className="text-center">
                            <Spinner animation="border" variant="primary" />
                            <p className="mt-2">Proses Simpan data, harap tunggu...</p>
                        </div>
                    )}
                </SweetAlert>
            }
            {
                simpanSuccess &&
                <SweetAlert
                    success
                    title="Simpan Data Alamat Berhasil"
                    onConfirm={handleCloseSimpanSuccess}
                    btnSize="sm"
                />
            }
            {
                simpanFailed &&
                <SweetAlert
                    danger
                    title="Simpan Data Alamat Gagal"
                    onConfirm={handleCloseSimpanFailed}
                    btnSize="sm"
                    timeout={2000}
                />                
            }
        </>
    )
}

export default TraderAlamatAddEdit